/**
 * TypeScript twin of the `$size-*` variables in `src/scss/_sizes.scss`, for the places that cannot call Sass: icon `width` / `height` attributes and
 * the `theme.ts` values. A size is a design-px number multiplied by the one scale variable, `--ui-unit`, on the golden-ratio ladder.
 * Keep `GOLDEN`, `RATIO` and `STEPS` identical to `$golden`, `$-ratio` and `$-steps` in `_sizes.scss`; `uiSize.test.ts` compiles the
 * real Sass table and fails when the two disagree (for example when a size is pinned in `$overrides`).
 *
 * Chrome and Firefox accept `calc()` with `var()` in the SVG `width` / `height` attributes, so icons keep them as attributes: a
 * stylesheet rule can still override them, which an inline `style` would not allow. `null` leaves sizing to the host's CSS; strings
 * that already carry a unit other than px pass through.
 */
const GOLDEN = true
const RATIO = 1.618034
const STEPS = 8

export function uiSize(size: number | string | null | undefined): string | undefined {
  if (size === null || size === undefined || size === '') return undefined

  const value = typeof size === 'number' ? size : /^\s*-?[0-9.]+(px)?\s*$/.test(size) ? Number.parseFloat(size) : null
  if (value === null) return String(size)
  if (value === 0) return '0'

  const abs = Math.abs(value)
  const factor = GOLDEN
    ? Math.round(RATIO ** (Math.round((STEPS * Math.log(abs)) / Math.log(RATIO)) / STEPS) * 10000) / 10000
    : abs

  return `calc(var(--ui-unit) * ${value < 0 ? -factor : factor})`
}
